<template>
	<div class="enter-pin-container form-container">
		<v-dialog />
		<div class="center-message">
			<p v-if="userName">Hi {{userName}},</p>
			<p>Please enter your PIN</p>
		</div>
		<div class="has-text-centered">
			<p>We sent a secure PIN to {{userPhone}}</p>
			<p>This code will expire in 10 minutes</p>
		</div>
		<div class="contact-form">
			<div class="contact-field">
				<input class="input text-input" type="tel" placeholder="Enter PIN" v-model="pin" />
			</div>
			<div class="contact-field">
				<BaseButton
					:classNames="['button--modifier', 'input-field-button']"
					title="Submit"
					type="scaleable-fixed-square"
					:disabled="!validPin"
					@click="handleClickSubmitPin"/>
			</div>
			<div class="padded-message has-text-centered">
				<p class="tp-link"
					aria-label="click here to receive a voice call with your pin number"
					@click="handleSendVoicePin">
					Trouble receiving PIN?
					<br/>
					Click <span class="underline-link">here</span> to get your PIN in a call.
				</p>
			</div>
			<div class="contact-field flex-center-content">
				<BaseButton
					:classNames="['button--modifier', 'input-field-button']"
					title="Request another PIN"
					type="standard-with-icon"
					@click="handleClickRequestPin">
					<BaseIcon
						class="input-field-icon icon-standard"
						:class="styleSpinner()"
						icon="sync"
						size="1x"/>
				</BaseButton>
			</div>
		</div>
	</div>
</template>

<script>
	import layoutMixin from '@Mixin/layoutMixin';
	import loginMixin from '@Mixin/loginMixin';
	import locationsMixin from '@Mixin/locationsMixin';
	import navigationMixin from '@Mixin/navigationMixin';
	import accountMixin from '@Mixin/accountMixin';
	import addressMixin from '@Mixin/addressMixin';
	// TODO move PIN in call to separate component
	import customerService from "@/services/customer.service";
	export default {
		mixins: [
			layoutMixin,
			loginMixin,
			navigationMixin,
			accountMixin,
			addressMixin,
		],
		components: {},
		props: {},
		data() {
			return {
				submittingPin: false,
				requestingPin: false,
			}
		},
		computed: {
			validPin() {
				const pin = this.pin;
				const pinLength = 5;
				return (pin.length === pinLength);
			}
		},
		methods: {
			handleCreateAccount(customerData) {
				customerService.editProfile({
					lb: this.location.id,
					c: {
						base: customerData.customer.base,
						firstname: this.guestName,
						lastname: '',
						phone: customerData.customer.phone,
					},
				}).then((response) => {
					const data = response.data;
					const body = data.body;
					const customer = body.customer;
					this.setCustomerLoggedIn(customer);
					this._addInitialAddress();
					if (this._hasCompletedRoute) {
						this._navigateToCompletedRoute();
						return;
					}
					this._navigateToCheckout();
				});
			},
			handleClickSubmitPin() {
				this.sendTokenRequest().then((response) => {
					const data = response.data;
					const message = data.message;
					if (message !== 'Successfully logged in') {
						// show error
						return;
					}
					const body = data.body;
					const customerData = body.customer;
					if (this.isNewAccount) {
						this.handleCreateAccount(customerData);
						return;
					}
					const raw = customerData && customerData.customer;
					this.setCustomerLoggedIn(raw);
					this._addInitialAddress();
					if (this._hasCompletedRoute) {
						this._navigateToCompletedRoute();
						return;
					}
					this._navigateToCheckout();
				});
			},
			showDialogPinSent() {
				this.$modal.show('dialog', {
					title: 'PIN Sent',
					text: 'Another PIN has been sent to your phone!',
					buttons: [
						{
							title: 'OK',
						},
					],
				});
			},
			handleClickRequestPin() {
				this.requestingPin = true;
				this.sendLoginRequest().then((response) => {
					// This timeout is for animation purposes
					// could be done with AnimeJS instead.
					setTimeout(() => {
						this.requestingPin = false;
						this.showDialogPinSent();
					}, 1000);
				});
			},
			handleSendVoicePin() {
				customerService.sendVoicePin();
			},
			styleSpinner() {
				return {
					'spin-active': this.requestingPin,
				};
			},
		},
		mounted() {
			this.setRouteLayout({
				name: 'Checkout',
				value: 'MinimalCheckout',
			});
		},
		created() {},
		destroyed() {},
	}
</script>

<style lang="scss" scoped>
	@import 'commonStyle/checkout';
	@import 'commonStyle/contactForm';
	@include mobile {}
	@include desktop {}
	@include tablet {}
</style>


// WEBPACK FOOTER //
// src/components/account/EnterPin.vue